import type { IV1ParsedData } from "./v1";

interface ICompletionsData {
    people: {
        id: string;
        name: string;
        teamName: string;
        orgName: string;
        groupName: string;
    }[];
    tasks: { id: string; shortTitle: string }[];
    completions: Map<string, Map<string, boolean>>;
    pastDeadlines: Map<string, Map<string, boolean>>;
    miles: Map<string, number> | undefined;
    counts: Map<string, Map<string, number>> | undefined;
    totals: Map<string, number>;
    state: {
        showNames: boolean;
        rowsPerColumn: number;
        groupBy: "person" | "group" | "org" | "team";
    };
}

interface IMilesBarData {
    chartData: {
        label: string;
        value: number;
    }[];
    checkpoint: number;
    goal: number;
    deadlineGoal: number;
}

interface IMilesLineData {
    chartData: (
        | {
              label: number;
              deadline: number;
          }
        | Record<string, number>
    )[];
    state: {
        yAxis: "total" | "average" | "team" | "group" | "org";
        xAxis: "day" | "week" | "month";
        relative: "calendar" | "path";
        linesDeadline: boolean;
        maxTicks: number;
    };
    teams: {
        id: string;
        name: string;
    }[];
    groups: {
        id: string;
        name: string;
    }[];
    orgs: {
        id: string;
        name: string;
    }[];
    checkpoint: number;
    goal: number;
}

interface ITaskCountLineData {
    chartData: (
        | {
              label: number;
          }
        | Record<string, number>
    )[];
    state: {
        xAxis: "day" | "week" | "month";
        relative: "calendar" | "path";
        maxTicks: number;
    };
    tasks: {
        id: string;
        shortTitle: string;
    }[];
    numMembers: number;
}

export type V2ChartDatum =
    | { chart: "miles-bar"; data: IMilesBarData; heading: string }
    | { chart: "miles-line"; data: IMilesLineData; heading: string }
    | { chart: "task-count"; data: ITaskCountLineData; heading: string }
    | { chart: "completions-table"; data: ICompletionsData; heading: string };

export interface IV2ParsedData {
    charts: V2ChartDatum[];
    version: 2;
    name: string;
}

export function v1tov2(v1Data: IV1ParsedData): IV2ParsedData {
    const v2Data: IV2ParsedData = {
        name: v1Data.name,
        version: 2,
        charts: v1Data.charts.map((chartDatum) => {
            if (chartDatum.chart === "completions-table") {
                return {
                    chart: "completions-table",
                    heading: chartDatum.heading,
                    data: {
                        ...chartDatum.data,
                        totals: new Map<string, number>(),
                        counts: undefined,
                        people: chartDatum.data.people.map((person) => ({
                            ...person,
                            teamName: "",
                            orgName: "",
                            groupName: "",
                        })),
                        state: {
                            ...chartDatum.data.state,
                            groupBy: "person",
                        },
                    },
                };
            }
            return chartDatum;
        }),
    };
    return v2Data;
}
